import { __rest } from "tslib";
import React from "react";
import getClass from "../utils/classNames";
var classMap = {
  xs: "col-xs",
  sm: "col-sm",
  md: "col-md",
  lg: "col-lg",
  xl: "col-xl",
  xsOffset: "col-xs-offset",
  smOffset: "col-sm-offset",
  mdOffset: "col-md-offset",
  lgOffset: "col-lg-offset",
  xlOffset: "col-xl-offset"
};

function isInteger(s) {
  return "number" == typeof s && isFinite(s) && Math.floor(s) === s;
}

function getColClassNames(s) {
  var t = ["col"];
  return s.className && t.push(s.className), s.first && t.push(getClass("first-" + s.first)), s.last && t.push(getClass("last-" + s.last)), Object.keys(s).filter(function (s) {
    return classMap[s];
  }).map(function (t) {
    return getClass(isInteger(s[t]) ? "".concat(classMap[t], "-").concat(s[t]) : classMap[t]);
  }).concat(t).join(" ");
}

export function Col(s) {
  var t = s.tagName,
      e = s.children,
      l = __rest(s, ["tagName", "children"]);

  return React.createElement(t || "div", {
    className: getColClassNames(l),
    children: e
  });
}
export default Col;